/**
 *  @Author PandaCure
 *  @DATE 2019-09-12
 *  @Project tw-website
 */
import React, { useState } from 'react'
import modalScss from './index.module.scss'
import modalClose from '@/assets/modal/modal_close.svg'

const CustomModal = props => {
  const [cancelActive, setCancelActive] = useState(false)
  const [sureActive, setSureActive] = useState(false)
  const {
    title,
    children,
    onCancel,
    onOk,
    visible,
    cancelText = '取消',
    showCancelButton = true,
    sureText = '確認',
    showSureButton = true,
    width = '',
    closeButtonEvent,
    closeButtonVisible = false,
    titleStyle = {},
    disableSubmit = false,
    zIndex = 999
  } = props
  return (
    <div
      className={modalScss.container}
      style={{ display: visible ? '' : 'none', zIndex: zIndex }}
    >
      <div className={modalScss.content} style={{ width }}>
        <div
          className={modalScss.close}
          onClick={closeButtonEvent}
          style={{ display: closeButtonVisible ? '' : 'none' }}
        >
          <img src={modalClose} alt="關閉" />
        </div>
        <div className={modalScss.title} style={{ ...titleStyle }}>
          {title}
        </div>
        <div className={modalScss.children}>{children}</div>
        <div className={modalScss.button_block}>
          <button
            className={modalScss.cancel}
            onClick={onCancel}
            style={{
              display: showCancelButton ? '' : 'none',
              color: cancelActive ? 'rgba(76, 98, 136, 1)' : ''
            }}
            onMouseEnter={() => setCancelActive(true)}
            onMouseLeave={() => setCancelActive(false)}
          >
            {cancelText}
          </button>
          <button
            className={modalScss.sure}
            onClick={onOk}
            style={{
              display: showSureButton ? '' : 'none',
              color: disableSubmit
                ? '#B7C0CF'
                : sureActive
                ? 'rgba(3, 110, 212, 1)'
                : ''
            }}
            onMouseEnter={() => setSureActive(true)}
            onMouseLeave={() => setSureActive(false)}
          >
            {sureText}
          </button>
        </div>
      </div>
    </div>
  )
}
export default CustomModal
